module.exports = __webpack_public_path__ + "static/img/1-1.4e2385f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/99/1-1.png
// module id = K8aP
// module chunks = 0